import { useSelector } from 'react-redux';

import { GetBannersParams } from '../__generated__/gateway/Api';
import { TAdMaterialTagsList, TBannersList } from '../interfaces/advertising';
import { getAdMaterialTags, getBanners, getIsLoadedBanners, getLoadingBanners } from '../selectors/advertising';

export function useBanners(alias?: string): TBannersList {
  return useSelector(getBanners(alias));
}

export function useLoadingBanners(type: GetBannersParams['BannerTypes'][number]): boolean {
  return useSelector(getLoadingBanners(type));
}

export function useIsLoadedBanners() {
  return useSelector(getIsLoadedBanners);
}

export function useAdMaterialTags(): TAdMaterialTagsList {
  return useSelector(getAdMaterialTags);
}
